import { Label, Panel, TableRow, TableRowDisplayEvent, Toast } from "@mcleod/components";
import { ModelRow, ModelSearchResult, UrlUtil } from "@mcleod/core";
import { AutogenLayoutAvailableTractorList } from "./autogen/AutogenLayoutAvailableTractorList";

export class AvailableTractorList extends AutogenLayoutAvailableTractorList {

    onLoad(): void | Promise<void> {
        this.addLayoutLoadListener(event => {
            const urlParams = UrlUtil.getPropsFromUrl(window.location.href);
            if (urlParams?.carrierId != null) {
                this.mainDataSource.search({'carrier_id': urlParams.carrierId, 'date_entered':'>t-30'}).then((result: ModelSearchResult) => {
                    if (result.modelRows.length < 1) {
                        Toast.showToast('No records entered in the last 30 days');
                    }
                })
            }
        })
    }

    tableAddedTractorsOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.target;
        const modelRow = tableRow.data as ModelRow;

        this.setupStatus(tableRow, modelRow);
    }

    setupStatus(tableRow: TableRow, modelRow: ModelRow) {
        const panel = tableRow?.findComponentById("panelStatus") as Panel;
        const labelStatus = panel.findComponentById("labelStatus") as Label;
        const status = modelRow.getString("status", "");
        if (panel != null) {
            if (status) {
                const bgColor = tableRow.data.get("status_color");
                if (bgColor === "#ffffff") {
                    panel.borderWidth = 1;
                    panel.borderColor = "primary";
                    panel.backgroundColor = bgColor;
                    labelStatus.color = "primary";
                } else {
                    panel.borderWidth = 0;
                    panel.backgroundColor = bgColor;
                    labelStatus.color = "default.reverse";
                }
                labelStatus.text = status;

            } else {
                labelStatus.color = "default";
                labelStatus.text = "--";
                panel.borderWidth = 1;
                panel.borderColor = "subtle";
            }
        }
    }
}